import { object, string } from 'yup';
import i18next from '@/i18next';
export const signInSchema = object({
    email: string().required(i18next.t('validation:required.users.email')),
    password: string().required(i18next.t('validation:required.users.password')),
});
